import { observer } from 'mobx-react-lite';
import './button-toolbar.scss';

type ButtonToolbarProps = {
  children: React.ReactNode;
}

const ButtonToolbar = observer<ButtonToolbarProps>((props) => {
  return <section className="button-toolbar">
    {props.children}
  </section>
});

export default ButtonToolbar;